import { render, staticRenderFns } from "./CalendarItemSection.vue?vue&type=template&id=4ad48d96&scoped=true"
import script from "./CalendarItemSection.vue?vue&type=script&lang=ts"
export * from "./CalendarItemSection.vue?vue&type=script&lang=ts"
import style0 from "./CalendarItemSection.vue?vue&type=style&index=0&id=4ad48d96&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ad48d96",
  null
  
)

export default component.exports